import React from 'react';
import Image from 'next/image';

import { useAuth } from '@edx/hooks/use-auth';
import { Button } from '@edx/components/button';
import { Intro, Title } from '@edx/components/typography';

type Props = {
  thumbnail: {
    src: string;
    alt: string;
  };
};

export const PlayerRestricted: React.FC<Props> = ({ thumbnail }) => {
  const { isLoggedIn, isLoggedOut } = useAuth();

  return (
    <div className="relative">
      <Image
        src={thumbnail.src}
        alt={thumbnail.alt}
        width={1120}
        height={630}
        layout="responsive"
        className="aspect-ratio-16/9"
      />

      <div className="absolute inset-0 flex flex-col justify-center text-center space-y-2 md:space-y-4 bg-gray-800 bg-opacity-80">
        <Intro tag="h2" size="small" className="md:text-intro text-gray-500">
          · Acceso restringido ·
        </Intro>

        <Title tag="h3" size="small" className="md:text-large text-gray-300 max-w-lg mx-auto leading-tight">
          {isLoggedIn
            ? 'Suscríbete y empieza a aprender. Sin límite'
            : 'Regístrate y accede a todos nuestros contenidos'}
        </Title>

        <ul className="flex justify-center">
          {isLoggedIn ? (
            <li>
              <Button variant="primary" href="/suscripcion">
                Suscríbete
              </Button>
            </li>
          ) : isLoggedOut ? (
            <li className="flex space-x-2">
              <Button variant="light" textVariant="medium" href="/login">
                Accede
              </Button>
              <Button variant="primary" textVariant="medium" href="/precio">
                Regístrate
              </Button>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
};
